import React, { useEffect } from 'react';

import { GeckoToastService } from 'ui';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import GeckoStore from 'services/gecko-store';
import { renderError } from 'services/gecko-error';
import Loader from 'components/Loader';

function TwitterOAuth({ twitterId }) {
  useEffect(() => {
    const accountId = GeckoStore.redux.get('appState.loggedInUser.account_id');
    const channel = {
      account_id: accountId,
      configuration: {
        twitter_id: twitterId,
      },
      type: 'twitter',
    };
    GeckoRequest.post('/channel/', channel)
      .then(() => {
        new GeckoToastService().success('Twitter channel successfully setup');
        GeckoLocation.goTo(`/settings/channels`);
      })
      .catch((err) => {
        renderError(err);
        GeckoLocation.goTo(`/settings/channels/new`);
      });
  }, []);
  return (
    <Loader isLoading={true}>
      <div>Setting up your Twitter Channel</div>
    </Loader>
  );
}

export default TwitterOAuth;
